import Component from './component';

Component.defaultProps = {
    isClosable: true,
};
export default Component;